import axios from "axios"
import setCalculatedValues from "./calculatedValues"

let siteName = "";
let siteLang = document.documentElement.lang;
let langOption = '';

if (window.location.href.indexOf("modus") > -1) {
    siteName = "modus";
} else if (window.location.href.indexOf("spargo") > -1) {
    siteName = "spargo";
} else if (window.location.href.indexOf("paymark") > -1) {
    siteName = "paymark";
} else if (window.location.href.indexOf("nordic") > -1) {
    siteName = "nordic";
} else if (window.location.href.indexOf("fokus") > -1) {
    siteName = "fokus";
} else if (window.location.href.indexOf("mini") > -1) {
    siteName = "mini";
} else if (window.location.href.indexOf("sales") > -1) {
    siteName = "sale-solution";
} else if (window.location.href.indexOf("der") > -1) {
    siteName = "der";
} else if (window.location.href.indexOf("viiga") > -1) {
		siteName = "viiga";
}


if (siteLang == 'nb') {
		langOption = 'no'
} else {
		langOption = 'se'
}
export default function loadJSON(e, t) {
    let loaddata = JSON.parse(sessionStorage.getItem('loaddata'));
    let siteID = sessionStorage.getItem('siteID');
    let siteLegacy = document.querySelector('[data-legacy]');
    let legacyID = "";
    if (siteLegacy) {
        legacyID = siteLegacy.dataset.legacy;
        if (!siteID) {
            siteID = legacyID;
        }
    }

    if (!loaddata) {
        if (siteName !== "sale-solution") {
						axios.get('/loaddata/' + legacyID + '-loaddata_' + langOption + '.json').then((response) => {
                loaddata = response.data
                sessionStorage.setItem('loaddata', JSON.stringify(response.data));

                //setCalculatedValues
                for (let i = 0; i < loaddata.months.length; i++) {
                    if (e == loaddata.months[i].amount && t == loaddata.months[i].month) {
                        const j = loaddata.months[i];

                        setCalculatedValues(
                            j.amount,
                            j.month,
                            j.monthlyPay,
                            j.debitrente,
                            j.creditTotal,
                            j.aop,
                            j.totalkreditcost,
                            j.kreditcost,
                            j.setupfeeloan
                        )
                    }
                }
            })
        } else {
            if (siteID) {
								axios.get('/loaddata/' + siteID + '-loaddata_' + langOption + '.json').then((response) => {
                    loaddata = response.data
                    sessionStorage.setItem('loaddata', JSON.stringify(response.data))

                    //setCalculatedValues
                    loaddata = JSON.parse(sessionStorage.getItem('loaddata'));

                    for (let i = 0; i < loaddata.months.length; i++) {
                        if (e == loaddata.months[i].amount && t == loaddata.months[i].month) {
                            const j = loaddata.months[i];
                            setCalculatedValues(
                                j.amount,
                                j.month,
                                j.monthlyPay,
                                j.debitrente,
                                j.creditTotal,
                                j.aop,
                                j.totalkreditcost,
                                j.kreditcost,
                                j.setupfeeloan
                            )
                        }
                    }
                })
            }
        }
    } else {

        //setCalculatedValues
        for (let i = 0; i < loaddata.months.length; i++) {
            if (e == loaddata.months[i].amount && t == loaddata.months[i].month) {
                const j = loaddata.months[i];

                setCalculatedValues(
                    j.amount,
                    j.month,
                    j.monthlyPay,
                    j.debitrente,
                    j.creditTotal,
                    j.aop,
                    j.totalkreditcost,
                    j.kreditcost,
                    j.setupfeeloan
                )
            }
        }
    }
}
